import {withRouter} from "react-router-dom";
import React from "react";
import {Logout} from "../actions/UserActions";
import {connect} from "react-redux";

function BackToLogin(props) {
  return (
    <a href={"/login"} onClick={(e) => {
      e.preventDefault();
      props.logout().then(() => {
        props.history.replace('/login'); 
      })
    }}>Go back to login page.</a>
  );
}

export default withRouter(connect<any, any, any, any>(() =>{}, {
    logout: Logout,
})(BackToLogin));